import { Modal } from "antd";
import { ReactNode } from "react";
import { getParentEl } from "../../../util/varibles/constants";

interface IPropsConfirm {
    content: string | ReactNode
    title?: string | ReactNode
    subContent?: string
    ok?: {
        text?: string
        danger?: boolean
        click?(): void
    }
    cancel?: {
        text?: string
        danger?: boolean
        click?(): void
    }
}

const modal = {
    confirm: (props: IPropsConfirm) => {
        const { danger = true } = props.ok || {};
        const modal = Modal.confirm({
            getContainer: getParentEl(),
            icon: null,
            content: <div className=' font-w4 font-s16'>{props.content}</div>,
            mask: { closable: true, },
            centered: true,
            okText: 'Confirm',
            width: 450,
            onOk: () => {
                modal.destroy();
                const { click } = props.ok || {}
                if (click)
                    click()
            },
            okButtonProps: {
                danger,
                className: ['font-w4', 'bt-danger'].join(' ')
            },
            cancelButtonProps: {
                className: ['font-w4', 'bt-default'].join(' ')
            }
        })
    },
    confirm2: (props: IPropsConfirm) => {
        const modal = Modal.confirm({
            getContainer: getParentEl(),
            icon: null,
            title: props.title,
            content: props.content,
            mask: { closable: true, },
            centered: true,
            okText: 'Confirm',
            width: 450,
            onOk: () => {
                modal.destroy();
                const { click } = props.ok || {}
                if (click)
                    click()
            },
            okButtonProps: {
                danger: props.ok?.danger,
                className: ['font-w4', 'bt-primary'].join(' ')
            },
            cancelButtonProps: {
                className: ['font-w4', 'bt-default'].join(' ')
            }
        })
    }
}

export default modal
